;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import canUseDOM from './canUseDOM'

export const getServerSideURL = () => {
    let url = process.env.NEXT_PUBLIC_SERVER_URL

    if (!url && process.env.VERCEL_PROJECT_PRODUCTION_URL) {
        return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
    }

    if (!url) {
        url = 'http://localhost:3000'
    }

    return url.replace(/\/+$/, '')
}

export const getClientSideURL = () => {
    if (canUseDOM) {
        const protocol = window.location.protocol
        const domain = window.location.hostname
        const port = window.location.port

        return `${protocol}//${domain}${port ? `:${port}` : ''}`
    }

    if (process.env.VERCEL_PROJECT_PRODUCTION_URL) {
        return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
    }

    return (process.env.NEXT_PUBLIC_SERVER_URL || '').replace(/\/+$/, '')
}
